/**
* Sticky Jump Links JS
* -----------------------------------------------------------------------------
*
* All the JS for the Sticky Jump Links component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'sticky-jump-links',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( window.innerWidth > 768 ) {
        $( '.sticky-jump-links__content' ).each( function() {
          let topOffset = $( 'header' ).height();
          if ( $( 'body.logged-in' ).length > 0 ) {
            topOffset += 32 + 86;
          }
          const buttonBottom = $( '.membership-button' ).offset().top + $( '.membership-button' ).outerHeight();
          const jumpLink = '#jump-link-' + $( this ).attr( 'id' );

          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: `top top+=${topOffset}`,
              end: `bottom top+=${topOffset}`,
              // markers: true,
              onEnter: () => updateActiveClasses( jumpLink, true ),
              onLeave: () => updateActiveClasses( jumpLink, false ),
              onEnterBack: () => updateActiveClasses( jumpLink, true ),
              onLeaveBack: () => updateActiveClasses( jumpLink, false ),
            },
          } );
        } );

        $( document ).on( 'click', '.jumper', function( e ) {
          e.preventDefault();

          const sectionId = $( this ).data( 'section-id' );
          const targetElement = $( '#' + sectionId );
          const headerHeight = $( 'header' ).outerHeight() + 86;
          const targetPosition = targetElement.offset().top - headerHeight;

          $( 'html, body' ).animate( {
            scrollTop: targetPosition,
          }, 500 );
        } );
      }

      function updateActiveClasses( jumpLink, isActive ) {
        const headingId = jumpLink.replace( '#jump-link-', '' );
        if ( isActive ) {
          $( jumpLink ).addClass( 'active' );
          $( '.hdg-5.' + headingId ).addClass( 'active text-brand-pink' );
        } else {
          $( jumpLink ).removeClass( 'active' );
          $( '.hdg-5.' + headingId ).removeClass( 'active text-brand-pink' );
        }
        $( '.sticky-jump-links__content .jumper' ).not( jumpLink ).removeClass( 'active' );
        $( '.sticky-jump-links__content .hdg-5' ).not( '.hdg-5.' + headingId ).removeClass( 'active text-brand-pink' );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'sticky-jump-links', COMPONENT );
} )( app );
